import 'ng-file-upload';
import 'angular-toastr';
import 'angular-ui-router';
import 'angular-translate';
import 'angularjs-color-picker';
import 'angular-clipboard';

import angular from 'angular';
import backgroundImage from './background_image_directive';
import capitalize from './capitalize_filter';
import copyButton from './copy_button.directive';
import contenteditable from './content_editable.directive';
import CurrentPartnerService from './current_partner.service';
import CurrentUserService from './current_user.service';
import ImageService from './image.service';
import imageSpecs from './image_specs.directive';
import videoSpecs from './video_specs.directive';
import FeatureFlagsController from './feature_flags.controller';
import NavSizeService from './nav_size.service';
import ProgressBarDirective from './progress_bar.directive';
import selectOnClick from './select_on_click.directive';
import SettingsService from '../settings.service';
import strAdminLinks from './links.directive';
import wysiwyg from './wysiwyg.directive';
import UrlValidationService from './url_validation.service';
import waitingOverlay from './waiting_overlay.directive';

angular.module('generator.shared', [
  'ngFileUpload',
  'ui.router',
  'pascalprecht.translate',
  'generator.creativePreview',
  'angular-clipboard',
  'sfa-angular-utils'
]);

angular
  .module('generator.shared')
  .controller('FeatureFlagsController', FeatureFlagsController)
  .directive('backgroundImage', backgroundImage)
  .directive('copyButton', copyButton)
  .directive('contenteditable', contenteditable)
  .directive('imageSpecs', imageSpecs)
  .directive('videoSpecs', videoSpecs)
  .directive('strProgressBar', ProgressBarDirective)
  .directive('selectOnClick', selectOnClick)
  .directive('strAdminLinks', strAdminLinks)
  .directive('waitingOverlay', waitingOverlay)
  .directive('wysiwygEditor', wysiwyg)
  .factory('CurrentUserService', CurrentUserService)
  .factory('ImageService', ImageService)
  .factory('NavSizeService', NavSizeService)
  .factory('UrlValidationService', UrlValidationService)
  .filter('capitalize', capitalize)
  .service('CurrentPartnerService', CurrentPartnerService)
  .service('SettingsService', SettingsService);
